module.exports = __webpack_public_path__ + "static/img/06-huette.b11d325.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/06-huette.jpg
// module id = 92
// module chunks = 0